import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import '@/permission'
import Vant from 'vant'
import 'vant/lib/index.css'
import '@/assets/scss/global.scss'

//import '@/assets/scss/iconfont/iconfont.css'// icon


// import util
import myUtil from './utils/util'
import auth from './utils/permission'// Utils
import goBack from './utils/goBack'// Utils
import {http} from './utils/request'// Utils
import Vuelidation from './utils/vuelidation'
import valid from './utils/valid'
import VueCountdown from './utils/vue-countdown'
import localStorageUtil from './utils/localStorageUtil'
import VueClipboard from 'vue-clipboard2'
import filters from './utils/filter'


import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

Vue.use(VueVideoPlayer)


import VueCanvasPoster from 'vue-canvas-poster'
Vue.use(VueCanvasPoster)


// use util
Vue.use(myUtil)
Vue.use(auth)
Vue.use(goBack)
Vue.use(http)
Vue.use(Vuelidation)
Vue.use(valid)
Vue.use(VueCountdown)
Vue.use(localStorageUtil)
Vue.use(VueClipboard)
Vue.use(filters)


// UI
Vue.use(Vant)
Vue.config.productionTip = false
Vue.config.isFirst=true


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
